var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.378 14.839c.344 0 .622.272.622.608a.615.615 0 01-.622.609H.622A.615.615 0 010 15.447c0-.336.278-.608.622-.608h15.756zm-.007-11.035l-9.87 9.656-3.848.385.393-3.764 8.583-8.397 1.288-1.26c.579-.566 1.588-.566 2.167 0l1.287 1.26a1.473 1.473 0 010 2.12zM4.046 12.482l1.888-.188 7.83-7.66-1.695-1.659-7.83 7.66-.193 1.847zM14 1.202a.29.29 0 00-.204.083l-.848.83 1.696 1.658.847-.83a.278.278 0 000-.398l-1.287-1.26A.29.29 0 0014 1.203z",
    fill: "#BEC8D2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.13fa03cd.svg";
export { ForwardRef as ReactComponent };